/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import './style.scoped.scss';
import { Link } from 'react-router-dom';
import { TranslateWorkaround, ROUTES } from '../../assets/constants/strings';
import { connect } from 'react-redux';
// import pluralize from 'pluralize';
import Logo from '../../assets/images/RC_Logo.svg';
import { FaBars, FaBookmark, FaCog } from 'react-icons/fa';
import { logOut } from '../../store/User/userActions';
import { ClearSearch } from '../../store/Search/searchActions';
import { hasBothPortals } from '../../services/entitlements';
import AccountMenu from '../AccountMenu';
// import $ from 'jquery';

const Header = ({
  hasNav,
  isHome = false,
  levelOnes,
  // logo,
  handleLevelSelected,
  logOut,
  ClearSearch,
  user,
}) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 768);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth > 768;
    setIsSmallScreen(screenRef.current);
  };

  const handleHome = () => {
    ClearSearch();
  };

  return (
    <header className='header'>
      {!isHome ? (
        <Link className='header__link' to={ROUTES.HOME} onClick={handleHome}>
          <img
            id='header-logo'
            className='header__BrandLogo'
            alt='logo'
            src={Logo}
          />
        </Link>
      ) : (
        <img
          className='header__BrandLogo'
          id='header-logo'
          alt='logo'
          src={Logo}
        />
      )}

      <div className='header__nav-wrapper'>
        <div className='header__account'>
          <Link
            to={ROUTES.BOOKMARKS}
            className='header__account__item'
            title='My Bookmarks'
            id='bookmarks-link'
          >
            <FaBookmark />
            <span>My Bookmarks</span>
          </Link>
          <div className='header__account__item dropdown'>
            <AccountMenu
              user={user}
              items={[
                {
                  title: 'Account Settings',
                  link: ROUTES.ACCOUNT_INFO,
                  icon: <FaCog />,
                },
              ]}
              switcher={
                hasBothPortals(user)
                  ? {
                      label: 'Developer API',
                      title: 'Switch to Developer API',
                      link: ROUTES.APIHOME,
                    }
                  : null
              }
              onLogout={() => logOut()}
            />
          </div>
        </div>
        {hasNav && (
          <div className='header__navigation dropdown'>
            <button
              id='header-dropdown'
              className='d-flex align-items-center tabIndex-btn p-0'
              data-toggle='dropdown'
              aria-haspopup='true'
              aria-expanded='false'
              tabIndex={0}
            >
              <FaBars />
            </button>
            <div className='dropdown-menu dropdown-menu-right'>
              {levelOnes &&
                levelOnes.map((level, i) => (
                  <div
                    key={i}
                    className={`dropdown-item active-override${TranslateWorkaround(
                      level.Title
                    )}`}
                    title={level.Title}
                    onClick={() => handleLevelSelected(level)}
                  >
                    {level.Title}
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  documents: state.client.documents,
  currentDocument: state.document.currentDocument,
  isPreview: state.client.isPreview,
  levelOnes: state.client.levelOneList,
  // logo: state.client.logo,
  user: state.user.user,
});

const mapDispatchToProps = { logOut, ClearSearch };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(Header);
